<script>
export default {
  created () {
    if (this.$listeners.popstate) {
      window.addEventListener('popstate', ({ state }) => this.$emit('popstate', state))
    }
  },

  render () {
    return this.$scopedSlots.default({
      pushState: this.pushState,
    })
  },

  methods: {
    pushState (state, url, options = {}) {
      history.pushState(state, '', url)

      if (options.preserveScroll === false) {
        window.scrollTo(0, 0)
      }
    },
  }
}
</script>
